export default "__VITE_ASSET__BH$tgbry__"